/**
 * 환경에 따라 API URL을 자동으로 설정
 * - 로컬 개발: http://localhost:5000
 * - 프로덕션: https://herbotapi.kwonyda.com
 */

const getApiUrl = (): string => {
  // 로컬 개발 환경 감지
  if (process.env.NODE_ENV === 'development') {
    console.log('[Config] Using local development API URL');
    return 'http://localhost:5000/api';
  }

  // 프로덕션 (EC2) 환경
  console.log('[Config] Using production API URL');
  return 'https://herbotapi.kwonyda.com/api';
};

export const config = {
  apiUrl: getApiUrl(),
  googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || '',
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
};

console.log('[Config] Application configuration:', {
  apiUrl: config.apiUrl,
  isDevelopment: config.isDevelopment,
  isProduction: config.isProduction,
});
